import { cn } from "@/lib/utils";

const sizes = {
  md: "h-10 px-4",
  sm: "h-9 px-3",
  xs: "h-8 px-3",
};

const SCALED_TEXT =
  "h-full w-[calc(100%/0.875)] shrink-0 origin-left scale-[0.875] sm:w-full sm:scale-100 sm:text-sm";

type DemoInputProps = Omit<React.ComponentProps<"input">, "size"> & {
  inputClassName?: string;
  size?: keyof typeof sizes;
};

export default function DemoInput({
  className,
  inputClassName,
  size = "md",
  ...props
}: DemoInputProps) {
  return (
    <div
      className={cn(
        "flex w-full items-center rounded-lg bg-preview-bg text-gray-1200 shadow-custom outline outline-transparent outline-offset-0 ring-0 ring-gray-900/20",
        "transition-[box-shadow,outline-color] duration-150 ease-out focus-within:ring-4",
        "has-aria-[invalid]:outline-red-500 has-aria-[invalid]:ring-red-500/25",
        sizes[size],
        className
      )}
    >
      <input
        className={cn(
          "bg-transparent text-base outline-none placeholder:text-gray-900",
          SCALED_TEXT,
          inputClassName
        )}
        {...props}
      />
    </div>
  );
}
